"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flummox = require("flummox");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuStore = (function (_Store) {
    _inherits(MenuStore, _Store);

    function MenuStore(flux) {
        _classCallCheck(this, MenuStore);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(MenuStore).call(this));

        var actions = flux.getActions("menu");
        _this.register(actions.setParams, _this.onSetParams);

        _this.state = {
            x: 0,
            y: 0,
            isVisible: false,
            currentItem: {}
        };
        return _this;
    }

    _createClass(MenuStore, [{
        key: "onSetParams",
        value: function onSetParams(params) {
            this.setState(params);
        }
    }]);

    return MenuStore;
})(_flummox.Store);

exports.default = MenuStore;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-contextmenu/modules/flux/store.js
 ** module id = 860
 ** module chunks = 0
 **/